// frontend/src/utils/textNormalizer.ts
// Türkçe TTS ses motorları için kapsamlı İngilizce, Yazılım, Fen, Biyoloji, Kimya, Fizik ve Matematik fonetik telaffuz haritası.

export class TextNormalizer {
  // Yazılım, Teknoloji, Fen, Biyoloji, Kimya, Fizik ve Matematik terimlerinin Türkçe ses motorunda kusursuz telaffuz haritası
  private static readonly PHONETIC_TERMS: Record<string, string> = {
    // ── Yazılım & Kodlama Hata Türleri ──
    'typeerror': 'tayp erır',
    'valueerror': 'valyu erır',
    'indexerror': 'indeks erır',
    'keyerror': 'kii erır',
    'syntaxerror': 'sintaks erır',
    'nameerror': 'neym erır',
    'attributeerror': 'etribyut erır',
    'zerodivisionerror': 'ziro divijın erır',
    'importerror': 'import erır',
    'indentationerror': 'indenteyşın erır',
    'modulenotfounderror': 'modyül nat faund erır',
    'filenotfounderror': 'fayl nat faund erır',
    'recursionerror': 'rikörjın erır',
    'overflowerror': 'ovırflov erır',
    'memoryerror': 'memori erır',
    'runtimeerror': 'rantaym erır',
    'assertionerror': 'asörşın erır',
    'keyboardinterrupt': 'kiybord intırapt',
    'timeouterror': 'taymaut erır',
    'permissionerror': 'pörmişın erır',
    'stopiteration': 'stap itıreyşın',
    'systemexit': 'sistım egsit',
    'unboundlocalerror': 'anbaund lokal erır',

    // ── Yazılım & Python Anahtar Kelimeleri & Kavramları ──
    'python': 'payton',
    'print': 'pırint',
    'def': 'def',
    'return': 'ritörn',
    'import': 'import',
    'from': 'from',
    'class': 'klas',
    'self': 'self',
    'init': 'init',
    '__init__': 'çift alt çizgi init çift alt çizgi',
    'lambda': 'lamda',
    'yield': 'yiild',
    'pass': 'pas',
    'break': 'breyk',
    'continue': 'kontinyu',
    'raise': 'reyz',
    'assert': 'asört',
    'global': 'global',
    'nonlocal': 'nan lokal',
    'try': 'tray',
    'except': 'eksept',
    'finally': 'faynıli',
    'with': 'vit',
    'as': 'ez',
    'async': 'esink',
    'await': 'eveyt',
    'function': 'fanksşın',
    'functions': 'fanksşınlar',
    'variable': 'veriyıbıl',
    'variables': 'veriyıbıllar',
    'loop': 'luup',
    'loops': 'luuplar',
    'string': 'string',
    'integer': 'inticır',
    'float': 'flot',
    'boolean': 'buliyan',
    'bool': 'buul',
    'tuple': 'tupıl',
    'list': 'list',
    'dict': 'dikt',
    'dictionary': 'dikşınari',
    'set': 'set',
    'none': 'nan',
    'null': 'nal',
    'undefined': 'andifaynd',
    'true': 'truu',
    'false': 'fols',
    'array': 'erey',
    'object': 'obcekt',
    'scope': 'skop',
    'stack': 'stek',
    'queue': 'kyuu',
    'heap': 'hiip',
    'tree': 'trii',
    'graph': 'graf',
    'pointer': 'poyntır',
    'parameter': 'parametre',
    'argument': 'argüman',
    'method': 'metod',
    'constructor': 'konstruktır',
    'inheritance': 'inherıtıns',
    'polymorphism': 'polimorfizm',
    'encapsulation': 'enkapsüleyşın',
    'abstraction': 'abstrekşın',
    'interface': 'interfeys',
    'override': 'ovırayd',
    'overload': 'ovırlood',
    'compiler': 'kompaylır',
    'interpreter': 'intırprıtır',
    'debugger': 'dibagır',
    'debug': 'dibag',
    'debugging': 'dibaging',
    'framework': 'freymvörk',
    'library': 'laybrıri',
    'module': 'modyül',
    'package': 'pekıc',
    'pip': 'pip',
    'npm': 'en pi em',
    'git': 'git',
    'github': 'git hab',
    'commit': 'komit',
    'push': 'puş',
    'pull': 'pul',
    'branch': 'brenç',
    'merge': 'mörc',
    'repository': 'repozitori',
    'repo': 'repo',
    'terminal': 'terminal',
    'console': 'konsol',
    'log': 'log',
    'input': 'input',
    'output': 'autput',
    'algorithm': 'algoritma',
    'code': 'kod',
    'script': 'skript',
    'html': 'heş tee em el',
    'css': 'sii es es',
    'javascript': 'cava skript',
    'typescript': 'taypskript',
    'react': 'riyakt',
    'vue': 'vyuu',
    'node': 'nood',
    'api': 'ey pi ay',
    'rest': 'rest',
    'json': 'ceysın',
    'database': 'deytabeys',
    'sql': 'es kyu el',
    'nosql': 'no es kyu el',
    'frontend': 'front end',
    'backend': 'bekend',
    'fullstack': 'fulstek',
    'devops': 'devops',
    'server': 'sörvır',
    'client': 'klayant',
    'request': 'rikvest',
    'response': 'rispans',
    'header': 'hedır',
    'body': 'badi',
    'payload': 'peylod',
    'cookie': 'kuki',
    'session': 'seşın',
    'token': 'tokın',
    'jwt': 'cey dabılyu ti',
    'auth': 'oht',
    'authentication': 'otentikeyşın',
    'authorization': 'otorizeyşın',
    'pygame': 'paygeym',
    'turtle': 'törtıl',
    'pyodide': 'payodayd',
    'ide': 'ay di i',
    'vscode': 'vi es kod',
    'ai': 'ey ay',

    // ── Fen & Biyoloji & Genetik ──
    'dna': 'de ne a',
    'rna': 're ne a',
    'mrna': 'me re ne a',
    'trna': 'te re ne a',
    'rrna': 're re ne a',
    'atp': 'a te pe',
    'adp': 'a de pe',
    'mitosis': 'mitoz',
    'meiosis': 'mayoz',
    'crossing over': 'krossing ovır',
    'polymerase': 'polimeraz',
    'helicase': 'helikaz',
    'ligase': 'ligaz',
    'ribosome': 'ribozom',
    'mitochondria': 'mitokondri',
    'chloroplast': 'kloroplast',
    'chlorophyll': 'klorofil',
    'photosynthesis': 'fotosentez',
    'ecosystem': 'ekosistem',
    'biodiversity': 'biyoçeşitlilik',
    'homeostasis': 'homeostazi',
    'enzyme': 'enzim',
    'substrate': 'substrat',
    'genotype': 'genotip',
    'phenotype': 'fenotip',
    'allele': 'alel',
    'heterozygous': 'heterozigot',
    'homozygous': 'homozigot',
    'chromosome': 'kromozom',
    'chromatid': 'kromatit',
    'centromere': 'sentromer',
    'interphase': 'interfaz',
    'prophase': 'profaz',
    'metaphase': 'metafaz',
    'anaphase': 'anafaz',
    'telophase': 'telofaz',
    'cytokinesis': 'sitokinez',
    'endocytosis': 'endositoz',
    'exocytosis': 'egzositoz',
    'osmosis': 'osmoz',
    'diffusion': 'difüzyon',

    // ── Fizik & Astronomi ──
    'quantum': 'kuantum',
    'photon': 'foton',
    'electron': 'elektron',
    'proton': 'proton',
    'neutron': 'nötron',
    'positron': 'pozitron',
    'quark': 'kuark',
    'neutrino': 'nötrino',
    'velocity': 'hız',
    'acceleration': 'ivme',
    'momentum': 'momentum',
    'impulse': 'itme',
    'torque': 'tork',
    'gravity': 'yerçekimi',
    'coulomb': 'kulomb',
    'tesla': 'tesla',
    'joule': 'jul',
    'watt': 'vat',
    'volt': 'volt',
    'ampere': 'amper',
    'ohm': 'om',
    'resistor': 'direnç',
    'capacitor': 'kondansatör',
    'inductor': 'bobin',
    'refraction': 'kırılma',
    'reflection': 'yansıma',
    'diffraction': 'kırınım',
    'interference': 'girişim',
    'doppler': 'dopler',
    'supernova': 'süpernova',
    'black hole': 'kara delik',
    'galaxy': 'galaksi',
    'light year': 'ışık yılı',

    // ── Kimya ──
    'molecule': 'molekül',
    'compound': 'bileşik',
    'element': 'element',
    'isotope': 'izotop',
    'ion': 'iyon',
    'cation': 'katyon',
    'anion': 'anyon',
    'molarity': 'molarite',
    'molality': 'molalite',
    'ph': 'pe haş',
    'poh': 'pe o haş',
    'covalent': 'kovalent',
    'ionic': 'iyonik',
    'endothermic': 'endotermik',
    'exothermic': 'ekzotermik',
    'catalyst': 'katalizör',
    'equilibrium': 'denge',
    'titration': 'titrasyon',
    'avogadro': 'avogadro',
    'hydrocarbon': 'hidrokarbon',
    'alkane': 'alkan',
    'alkene': 'alken',
    'alkyne': 'alkin',
    'polymer': 'polimer',
    'monomer': 'monomer',

    // ── Matematik Sembolleri & Terimleri ──
    'integral': 'integral',
    'derivative': 'türev',
    'limit': 'limit',
    'logarithm': 'logaritma',
    'ln': 'el en',
    'trigonometry': 'trigonometri',
    'sin': 'sinüs',
    'cos': 'kosinüs',
    'tan': 'tanjant',
    'cot': 'kotanjant',
    'sec': 'sekant',
    'csc': 'kosekant',
    'polynomial': 'polinom',
    'parabola': 'parabol',
    'hyperbola': 'hiperbol',
    'ellipse': 'elips',
    'matrix': 'matris',
    'determinant': 'determinant',
    'vector': 'vektör',
    'scalar': 'skaler',
    'infinity': 'sonsuz',
    'delta': 'delta',
    'pi': 'pi',
    'sigma': 'sigma',
    'theta': 'teta',
    'alpha': 'alfa',
    'beta': 'beta',
    'gamma': 'gama',
  };

  // Akıllı Kısaltmalar ve Semboller Sözlüğü
  private static readonly ABBREVIATIONS: Record<string, string> = {
    'A.Ş.': 'Anonim Şirketi',
    'A.Ş': 'Anonim Şirketi',
    'Ltd.': 'Limited Şirketi',
    'Ltd': 'Limited Şirketi',
    'Dr.': 'Doktor',
    'Dr': 'Doktor',
    'Prof.': 'Profesör',
    'Prof': 'Profesör',
    'Mah.': 'Mahallesi',
    'Cad.': 'Caddesi',
    'Sok.': 'Sokağı',
    'No.': 'Numara',
    'No': 'Numara',
    'vb.': 've benzeri',
    'vb': 've benzeri',
    'vs.': 've saire',
    'vs': 've saire',
    'minikcoder': 'minik koder',
  };

  /**
   * Güvenli HTML Çözümleme (DOMParser kullanarak)
   */
  public static decodeHtml(htmlText: string): string {
    if (!htmlText) return '';
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, 'text/html');
      return doc.body.textContent || doc.documentElement.textContent || htmlText;
    } catch {
      if (typeof document !== 'undefined') {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = htmlText;
        return textarea.value;
      }
      return htmlText;
    }
  }

  /**
   * Kısaltmaları ve sembolleri Türkçe telaffuzuna uygun hale getirir.
   */
  public static normalizeAbbreviations(text: string): string {
    let normalized = text;

    normalized = normalized.replace(/%/g, ' yüzde ');
    normalized = normalized.replace(/&/g, ' ve ');

    for (const [abbr, replacement] of Object.entries(this.ABBREVIATIONS)) {
      const escapedAbbr = abbr.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = new RegExp(`\\b${escapedAbbr}\\b`, 'gi');
      normalized = normalized.replace(regex, replacement);
    }

    return normalized;
  }

  /**
   * Markdown temizleme ve genel metin arındırma
   */
  public static cleanMarkdown(markdown: string): string {
    if (!markdown) return '';
    let text = markdown;

    // 00. Görsel tanımlarını, sahneleri, sütun ve mizanpaj bloklarını temizle
    text = text.replace(/\[(?:GÖRSEL|GORSEL|ŞEKİL|SEKIL|ÇİZİM|CIZIM|DİYAGRAM|DIAGRAM|TABLO|PANEL|SAHNE|ANİMASYON|ANIMASYON|GRAFİK|GRAFIK|SÜTUN|SUTUN)[-_ ]?(?:TANIMI|tanimi|AÇIKLAMASI|aciklamasi|BETİMLEMESİ|betimlemesi)?:\s*[\s\S]*?\]/gi, '');
    text = text.replace(/\[(?:GÖRSEL|GORSEL|ŞEKİL|SEKIL|ÇİZİM|CIZIM|DİYAGRAM|DIAGRAM|TABLO|PANEL|SAHNE)[-_ ]?[^\]]*:[\s\S]*/gi, '');
    text = text.replace(/\[[^\]]*#[0-9a-fA-F]{3,8}[\s\S]*?\]/gi, '');
    text = text.replace(/\[[^\]]*(?:çerçeveli|kutucuğu|yer alır|sütun|diyagram|mizanpaj|şablon)[\s\S]*?\]/gi, '');
    text = text.replace(/\[[^\]]*(?:görsel|şekil|çizim|diyagram|sütun|çerçeve|kutucuğu|yer alır)[\s\S]*$/gi, '');

    // 00b. Tüm HEX renk kodlarını ve "mor çerçeveli", "yeşil renkli" gibi yapay etiketleri temizle
    text = text.replace(/#[0-9a-fA-F]{6}\b\s*(?:mor|yeşil|mavi|kırmızı|sarı|turuncu|pembe|gri|siyah|beyaz)?\s*(?:çerçeveli|renkli|çizgili)?/gi, ' ');
    text = text.replace(/#[0-9a-fA-F]{3,8}\b/gi, ' ');

    // 0. "Slayt X:" veya "Bölüm X:" veya "Örnek X:" gibi kalıpları ve numaraları temizle
    text = text.replace(/Slayt\s*\d+\s*:?/gi, '');
    text = text.replace(/Bölüm\s*\d+\s*:?/gi, '');
    text = text.replace(/Örnek\s*\d+\s*:?/gi, 'Örnek, ');

    // 0b. LaTeX komutlarını ve matematik kodlarını temizle
    text = text.replace(/\\[a-zA-Z]+/g, ' ');
    text = text.replace(/\$/g, '');

    // 0c. Markdown yatay çizgi ayırıcılarını temizle
    text = text.replace(/^\s*[-*_]{3,}\s*$/gm, ' ');

    // 0d. Yapısal slayt/bölüm başlık kelimelerini atla
    const STRUCTURAL_WORDS = [
      'giriş', 'gelişme', 'sonuç', 'açılış', 'kapatış', 'kapanış', 'değerlendirme',
      'geçiş', 'hede', 'hedefler', 'özet', 'özetleme', 'aktivite', 'aktiviteler',
      'introduction', 'conclusion', 'summary', 'overview',
    ];
    const structuralPattern = new RegExp(
      `^\\s*(?:#+\\s*)?(?:\\d+[.\\-)]\\s*)?(?:\\*{1,2})?(?:${STRUCTURAL_WORDS.join('|')})[:\\s]*(?:\\*{1,2})?\\s*$,`,
      'gim'
    );
    text = text.replace(structuralPattern, ' ');

    // 1. Kod bloklarını temizle
    text = text.replace(/```[\s\S]*?```/g, '. Ekrandaki örnek koda bakın. ');

    // 2. Başlık işaretlerini (#) ve kalın/italik/inline kod işaretlerini (*, _, `) temizle
    text = text.replace(/#+\s/g, '');
    text = text.replace(/[*_]{1,2}/g, '');
    text = text.replace(/`([^`]+)`/g, '$1');
    text = text.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');

    // 3. Emojileri temizle
    text = text.replace(/[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F700}-\u{1F77F}]|[\u{1F780}-\u{1F7FF}]|[\u{1F800}-\u{1F8FF}]|[\u{1F900}-\u{1F9FF}]|[\u{1FA00}-\u{1FA6F}]|[\u{1FA70}-\u{1FAFF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]/gu, '');

    // 4. Liste işaretlerini ve satır başındaki başlık numaralarını temizle
    text = text.replace(/^\s*[-*•]\s+/gm, '');
    text = text.replace(/^\s*\d+\.\s+/gm, '');

    // 5. Paragraf ve boşlukları düzelt
    text = text.replace(/\n{2,}/g, '. ');
    text = text.replace(/\n/g, ', ');

    // 6. Parantez içi kısa ek açıklamaları ses tonu için virgüllere çevir, uzunları yut
    text = text.replace(/\(([^)]{0,20})\)/g, ', $1, ');
    text = text.replace(/\(([^)]{20,})\)/g, '');

    // 7. Diğer noktalama ve sembolleri yut
    text = text.replace(/[{}[\]<>|\\~/^=+]/g, '');
    text = text.replace(/:+/g, ', ');
    text = text.replace(/\.{3,}/g, '.');
    text = text.replace(/,{2,}/g, ',');
    text = text.replace(/\.\s*,/g, '.');
    text = text.replace(/,\s*\./g, '.');
    text = text.replace(/-{2,}/g, ' ');

    return text;
  }

  /**
   * İngilizce, Yazılım, Fen, Biyoloji, Kimya ve Fizik terimlerini Türkçe fonetik karşılıklarına çevirir.
   */
  public static normalizePhonetics(text: string): string {
    let normalized = text;
    for (const [term, phonetic] of Object.entries(this.PHONETIC_TERMS)) {
      const escaped = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = new RegExp(`\\b${escaped}\\b`, 'gi');
      normalized = normalized.replace(regex, phonetic);
    }
    return normalized;
  }

  /**
   * Tam Normalizasyon Zinciri (Sanitization Pipeline)
   */
  public static normalize(markdownText: string): string {
    let text = this.decodeHtml(markdownText);
    text = this.cleanMarkdown(text);
    text = this.normalizeAbbreviations(text);
    text = this.normalizePhonetics(text);
    return text.replace(/\s{2,}/g, ' ').trim();
  }

  /**
   * Kesin Ses Eşleştirme (Strict Voice Binding)
   */
  public static getStrictTurkishVoice(): SpeechSynthesisVoice | null {
    if (typeof window === 'undefined' || !window.speechSynthesis) return null;

    const voices = window.speechSynthesis.getVoices();
    if (!voices || voices.length === 0) return null;

    const turkishVoices = voices.filter((voice) => 
      (voice.lang.toLowerCase().includes('tr') || 
      voice.name.toLowerCase().includes('turkish') ||
      voice.name.toLowerCase().includes('türkçe')) &&
      !voice.name.toLowerCase().includes('tolga')
    );

    if (turkishVoices.length === 0) return null;

    const edgeNaturalFemale = turkishVoices.find((v) => v.name.toLowerCase().includes('emel online (natural)'));
    if (edgeNaturalFemale) return edgeNaturalFemale;

    const windowsFemale = turkishVoices.find((v) => v.name.toLowerCase().includes('emel'));
    if (windowsFemale) return windowsFemale;

    const appleFemale = turkishVoices.find((v) => v.name.toLowerCase().includes('yelda'));
    if (appleFemale) return appleFemale;

    const googleVoice = turkishVoices.find((v) => v.name.toLowerCase().includes('google'));
    if (googleVoice) return googleVoice;

    return turkishVoices[0];
  }
}
